import { Controller } from "@hotwired/stimulus"

// Filtro, ordinamento e vista (griglia/lista) sulla collezione già in pagina.
// Vista e ordinamento restano in localStorage; il filtro è per sessione.
export default class extends Controller {
  static targets = ["search", "searchAll", "chip", "sort", "gridBtn", "listBtn", "grid", "list", "hint", "noMatch"]

  connect() {
    this._kind = "all"
    this.setView({ params: { view: localStorage.getItem("cloud:view") || "grid" } }, false)
    if (this.hasSortTarget) {
      const saved = localStorage.getItem("cloud:sort")
      if (saved && Array.from(this.sortTarget.options).some((o) => o.value === saved)) this.sortTarget.value = saved
      this.applySort(this.sortTarget.value)
    }
    this.markActiveChip()
  }

  setView(event, persist = true) {
    const view = event?.params?.view || event?.currentTarget?.dataset?.view || "grid"
    const grid = view === "grid"
    if (this.hasGridTarget) this.gridTarget.classList.toggle("hidden", !grid)
    if (this.hasListTarget) this.listTarget.classList.toggle("hidden", grid)
    if (this.hasGridBtnTarget) this.gridBtnTarget.classList.toggle("btn-active", grid)
    if (this.hasListBtnTarget) this.listBtnTarget.classList.toggle("btn-active", !grid)
    if (this.hasGridBtnTarget) this.gridBtnTarget.setAttribute("aria-pressed", grid)
    if (this.hasListBtnTarget) this.listBtnTarget.setAttribute("aria-pressed", !grid)
    if (persist !== false) localStorage.setItem("cloud:view", view)
  }

  setFilter(event) {
    this._kind = event.currentTarget.dataset.kind
    this.markActiveChip()
    this.apply()
  }

  filter() {
    this.apply()
    this.updateSearchAll()
  }

  // Invio nel campo: ricerca in tutto il Cloud.
  searchAll(event) {
    const term = this.term()
    if (term.length < 2) return
    event.preventDefault()
    window.Turbo.visit(this.searchUrl(term))
  }

  apply() {
    const term = this.term()
    let shown = 0
    let total = 0
    this.items().forEach((el) => {
      const matchKind = this._kind === "all" || el.dataset.kind === this._kind
      const matchTerm = !term || el.dataset.name.includes(term) || (el.dataset.ext || "").includes(term)
      const show = matchKind && matchTerm
      el.classList.toggle("hidden", !show)
      if (el.closest("#cloud_grid")) { total++; if (show) shown++ }
    })
    if (this.hasHintTarget) {
      const filtering = term || this._kind !== "all"
      this.hintTarget.hidden = !filtering
      this.hintTarget.textContent = filtering ? `${shown} / ${total}` : ""
    }
    if (this.hasNoMatchTarget) this.noMatchTarget.hidden = !(total > 0 && shown === 0)
  }

  sort(event) {
    const value = event.currentTarget.value
    localStorage.setItem("cloud:sort", value)
    this.applySort(value)
  }

  applySort(value) {
    const [key, dir] = (value || "name-asc").split("-")
    const factor = dir === "desc" ? -1 : 1
    const read = (el) => {
      if (key === "name") return el.dataset.name
      if (key === "kind") return `${el.dataset.kind}:${el.dataset.ext}:${el.dataset.name}`
      return Number(el.dataset[key] || 0)
    }
    this.containers().forEach((container) => {
      const nodes = Array.from(container.querySelectorAll(":scope > [data-cloud-item]"))
      nodes.sort((a, b) => {
        const av = read(a); const bv = read(b)
        return (av > bv ? 1 : av < bv ? -1 : 0) * factor
      })
      nodes.forEach((n) => container.appendChild(n))
    })
  }

  term() {
    return (this.hasSearchTarget ? this.searchTarget.value : "").trim().toLowerCase()
  }

  searchUrl(term) {
    const base = this.searchTarget.dataset.cloudToolbarSearchUrlParam || "/cloud"
    return `${base}?q=${encodeURIComponent(term)}`
  }

  updateSearchAll() {
    if (!this.hasSearchAllTarget) return
    const term = this.term()
    this.searchAllTarget.hidden = term.length < 2
    if (term.length >= 2) this.searchAllTarget.href = this.searchUrl(term)
  }

  containers() {
    return [this.hasGridTarget ? this.gridTarget : null, this.hasListTarget ? this.listTarget : null].filter(Boolean)
  }

  items() {
    return this.containers().flatMap((c) => Array.from(c.querySelectorAll(":scope > [data-cloud-item]")))
  }

  markActiveChip() {
    this.chipTargets.forEach((c) => {
      const active = c.dataset.kind === this._kind
      c.classList.toggle("is-active", active)
      c.setAttribute("aria-pressed", active)
    })
  }
}
